import { render, staticRenderFns } from "./CreateEditCategoriaContaModal.vue?vue&type=template&id=491de1ce&"
import script from "./CreateEditCategoriaContaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditCategoriaContaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports